export const API_NOTI_SYSTEMS = '/thong-bao';
export const API_SETTING_DEFAULT_VALUE = '/setting';
export const API_ADD_MEMBER_ORGANIZATIONS = '/them-thanh-vien';
